import { CSVProfile } from '../../types'
import { TableDataChartComponent } from '../charts/table-data-chart-component'
import { TRANSFORM_EXCLUDE_KEY } from '../commons/constants'

export class AFTopSharedLink extends TableDataChartComponent {
 static config = {
  selector: 'afTopSharedLink',
  controller: AFTopSharedLink,
  bindings: TableDataChartComponent.config.bindings,
  template: TableDataChartComponent.config.template,
 }

 public csvHeaders = ['URL Links', 'Mentions', 'Shared URL']

  buildTableDataOptions() {
    return ['URL Links', 'explore__visualizations--key-metrics-mentions']
  }

  buildTableDataChartData(data) {
    // calculate indexes for pagination
    let startIndex = this.pagination.currentPage * this.pagination.pageSize
    let endIndex = this.pagination.currentPage * this.pagination.pageSize + this.pagination.pageSize
    return data.slice(startIndex, endIndex).map(x => ({
      ...x,
      profileUrl: x.profileUrl.includes('http') ? x.profileUrl: '//'+x.profileUrl,
      imageSource: 'actions:attachment',
      haloColor: '#3B5C87'
    }))
  }
}
